/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryMethod,
  PurchaseDeliveryMethodOptional,
  PurchaseDeliveryMethodMetaI,
  PurchaseDeliveryMethodTrackedI,
} from "./purchase-delivery-method";
import {
  PurchaseDeliveryMethodTracked,
  PurchaseDeliveryMethodMeta,
} from "./purchase-delivery-method";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryStatus,
  PurchaseDeliveryStatusOptional,
  PurchaseDeliveryStatusMetaI,
  PurchaseDeliveryStatusTrackedI,
} from "./purchase-delivery-status";
import {
  PurchaseDeliveryStatusTracked,
  PurchaseDeliveryStatusMeta,
} from "./purchase-delivery-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseDeliveryTarget,
  PurchaseDeliveryTargetOptional,
  PurchaseDeliveryTargetMetaI,
  PurchaseDeliveryTargetTrackedI,
} from "./purchase-delivery-target";
import {
  PurchaseDeliveryTargetTracked,
  PurchaseDeliveryTargetMeta,
} from "./purchase-delivery-target";

/**
 *
 * @export
 * @interface PurchaseDeliveryBase
 */
export interface PurchaseDeliveryBaseOptional {
  /**
   *
   * @type {PurchaseDeliveryTarget}
   * @memberof PurchaseDeliveryBase
   */
  target?: PurchaseDeliveryTarget;
  /**
   *
   * @type {PurchaseDeliveryMethod}
   * @memberof PurchaseDeliveryBase
   */
  method?: PurchaseDeliveryMethod;
  /**
   *
   * @type {PurchaseDeliveryStatus}
   * @memberof PurchaseDeliveryBase
   */
  deliveryStatus?: PurchaseDeliveryStatus;
  /**
   *
   * @type {string}
   * @memberof PurchaseDeliveryBase
   */
  deliveredOn?: Date;
}

export interface PurchaseDeliveryBase extends PurchaseDeliveryBaseOptional {
  /**
   *
   * @type {PurchaseDeliveryTarget}
   * @memberof PurchaseDeliveryBase
   */
  target?: PurchaseDeliveryTarget;
  /**
   *
   * @type {PurchaseDeliveryMethod}
   * @memberof PurchaseDeliveryBase
   */
  method?: PurchaseDeliveryMethod;
  /**
   *
   * @type {PurchaseDeliveryStatus}
   * @memberof PurchaseDeliveryBase
   */
  deliveryStatus?: PurchaseDeliveryStatus;
  /**
   *
   * @type {string}
   * @memberof PurchaseDeliveryBase
   */
  deliveredOn?: Date;
}

export interface PurchaseDeliveryBaseTrackedI {
  /**
   *
   * @type {PurchaseDeliveryTarget}
   * @memberof PurchaseDeliveryBase
   */
  target?: PurchaseDeliveryTarget;
  targetIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryMethod}
   * @memberof PurchaseDeliveryBase
   */
  method?: PurchaseDeliveryMethod;
  methodIsSet: boolean;
  /**
   *
   * @type {PurchaseDeliveryStatus}
   * @memberof PurchaseDeliveryBase
   */
  deliveryStatus?: PurchaseDeliveryStatus;
  deliveryStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseDeliveryBase
   */
  deliveredOn?: Date;
  deliveredOnIsSet: boolean;
}

transformDatesMap.set(
  "PurchaseDeliveryBase",
  function (model: PurchaseDeliveryBase) {
    if (typeof model.deliveredOn == "string")
      model.deliveredOn = new Date(model.deliveredOn);
  },
);

export type PurchaseDeliveryBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  target: PropertyMeta<PurchaseDeliveryTargetMetaI>;
  //isDate: false
  //isDatetime: false
  method: PropertyMeta<PurchaseDeliveryMethodMetaI>;
  //isDate: false
  //isDatetime: false
  deliveryStatus: PropertyMeta<PurchaseDeliveryStatusMetaI>;
  //isDate: false
  //isDatetime: true
  deliveredOn: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var PurchaseDeliveryBaseMeta: PurchaseDeliveryBaseMetaI =
  {} as PurchaseDeliveryBaseMetaI;
PurchaseDeliveryBaseMeta = typeMeta("PurchaseDeliveryBase", {
  target: propertyMeta(
    "target",
    false,
    false,
    false,
    PurchaseDeliveryTargetMeta,
  ),
  method: propertyMeta(
    "method",
    false,
    false,
    false,
    PurchaseDeliveryMethodMeta,
  ),
  deliveryStatus: propertyMeta(
    "deliveryStatus",
    false,
    false,
    false,
    PurchaseDeliveryStatusMeta,
  ),
  deliveredOn: propertyMeta(
    "deliveredOn",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = PurchaseDeliveryBaseMeta;

registerMeta(() => {});

export class PurchaseDeliveryBaseTracked implements PurchaseDeliveryBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  target__I?: PurchaseDeliveryTarget = undefined;
  targetIsSet: boolean = false;
  set target(v: undefined | PurchaseDeliveryTarget) {
    if (v !== undefined) {
      this.target__I = v;
      this.targetIsSet = true;
    } else {
      this.target__I = v || undefined;
      this.targetIsSet = false;
    }
    this.changeTracker = true;
  }
  get target() {
    return this.target__I;
  }
  method__I?: PurchaseDeliveryMethod = undefined;
  methodIsSet: boolean = false;
  set method(v: undefined | PurchaseDeliveryMethod) {
    if (v !== undefined) {
      this.method__I = v;
      this.methodIsSet = true;
    } else {
      this.method__I = v || undefined;
      this.methodIsSet = false;
    }
    this.changeTracker = true;
  }
  get method() {
    return this.method__I;
  }
  deliveryStatus__I?: PurchaseDeliveryStatus = undefined;
  deliveryStatusIsSet: boolean = false;
  set deliveryStatus(v: undefined | PurchaseDeliveryStatus) {
    if (v !== undefined) {
      this.deliveryStatus__I = v;
      this.deliveryStatusIsSet = true;
    } else {
      this.deliveryStatus__I = v || undefined;
      this.deliveryStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get deliveryStatus() {
    return this.deliveryStatus__I;
  }
  deliveredOn__I?: Date = undefined;
  deliveredOnIsSet: boolean = false;
  set deliveredOn(v: undefined | Date) {
    if (v !== undefined) {
      this.deliveredOn__I = v;
      this.deliveredOnIsSet = true;
    } else {
      this.deliveredOn__I = v || undefined;
      this.deliveredOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get deliveredOn() {
    return this.deliveredOn__I;
  }
  constructor(config?: PurchaseDeliveryBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PurchaseDeliveryBaseOptional,
    options?: AssignOptions,
  ): PurchaseDeliveryBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.target && this.targetApplyFilter(optionsRequired.filter)) {
      this.target = config.target;
      if (optionsRequired.unassign) this.targetIsSet = false;
      else this.targetIsSet = true;
    }
    if (config.method && this.methodApplyFilter(optionsRequired.filter)) {
      this.method = config.method;
      if (optionsRequired.unassign) this.methodIsSet = false;
      else this.methodIsSet = true;
    }
    if (
      config.deliveryStatus &&
      this.deliveryStatusApplyFilter(optionsRequired.filter)
    ) {
      this.deliveryStatus = config.deliveryStatus;
      if (optionsRequired.unassign) this.deliveryStatusIsSet = false;
      else this.deliveryStatusIsSet = true;
    }
    if (
      config.deliveredOn &&
      this.deliveredOnApplyFilter(optionsRequired.filter)
    ) {
      this.deliveredOn = config.deliveredOn;
      if (optionsRequired.unassign) this.deliveredOnIsSet = false;
      else this.deliveredOnIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseDeliveryBaseTrackedI {
    const cloned = {} as PurchaseDeliveryBaseTrackedI;
    if (
      this.targetIsSetDeep() &&
      this.targetApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.targetIsSet = true;
      cloned.target = this.target;
    } else {
      //cloned.targetIsSet = false
    }
    if (
      this.methodIsSetDeep() &&
      this.methodApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.methodIsSet = true;
      cloned.method = this.method;
    } else {
      //cloned.methodIsSet = false
    }
    if (
      this.deliveryStatusIsSetDeep() &&
      this.deliveryStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.deliveryStatusIsSet = true;
      cloned.deliveryStatus = this.deliveryStatus;
    } else {
      //cloned.deliveryStatusIsSet = false
    }
    if (
      this.deliveredOnIsSetDeep() &&
      this.deliveredOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.deliveredOnIsSet = true;
      cloned.deliveredOn = this.deliveredOn;
    } else {
      //cloned.deliveredOnIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseDeliveryBaseTrackedI {
    if (!this.targetApplyFilter(filter)) this.targetIsSet = false;

    if (!this.methodApplyFilter(filter)) this.methodIsSet = false;

    if (!this.deliveryStatusApplyFilter(filter))
      this.deliveryStatusIsSet = false;

    if (!this.deliveredOnApplyFilter(filter)) this.deliveredOnIsSet = false;

    return this;
  }
  targetApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryBaseMeta.target,
      PurchaseDeliveryBaseMeta,
      this.target,
      this,
    );
  }
  targetIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.targetIsSet && this.targetApplyFilter(filter)) return true;

    return false;
  }
  methodApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryBaseMeta.method,
      PurchaseDeliveryBaseMeta,
      this.method,
      this,
    );
  }
  methodIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.methodIsSet && this.methodApplyFilter(filter)) return true;

    return false;
  }
  deliveryStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryBaseMeta.deliveryStatus,
      PurchaseDeliveryBaseMeta,
      this.deliveryStatus,
      this,
    );
  }
  deliveryStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.deliveryStatusIsSet && this.deliveryStatusApplyFilter(filter))
      return true;

    return false;
  }
  deliveredOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseDeliveryBaseMeta.deliveredOn,
      PurchaseDeliveryBaseMeta,
      this.deliveredOn,
      this,
    );
  }
  deliveredOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.deliveredOnIsSet && this.deliveredOnApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.targetIsSetDeep(filter)) return true;
    if (this.methodIsSetDeep(filter)) return true;
    if (this.deliveryStatusIsSetDeep(filter)) return true;
    if (this.deliveredOnIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
